import { startOfDay, isSameDay, isWithinInterval } from "date-fns";

/**
 * Checks if a meeting date matches the given date range.
 * @param {Date} meetingTime - The meeting time to check.
 * @param {Object} dateRange - The date range with `start` and `end` properties.
 * @returns {boolean} - True if the meeting time matches the date range, otherwise false.
 */
export const matchesMeetingsByDateRange = (meetingTime, dateRange) => {
    if (!dateRange) return true;

    const meetingDate = startOfDay(new Date(meetingTime));
    const rangeStart = startOfDay(dateRange.start);
    const rangeEnd = startOfDay(dateRange.end);

    return (
        isSameDay(meetingDate, rangeStart) ||
        isWithinInterval(meetingDate, { start: rangeStart, end: rangeEnd })
    );
};